import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { IPeriodsTableRows } from 'components/BusinessToolForm/constants/periods';
import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetTotalCurrentLiabilitiesCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [currentLiabilitiesFiled] = observedFields.currentLiabilitiesTotal.setCalculatedValueFieldNames;

  const getTotalCurrentLiabilitiesCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const currentLiabilitiesTableValues = Object.values(content[0]) as IPeriodsTableRows[];
        const currentLiabilitiesTotal = summarizeSubtractPeriodValues(
          currentLiabilitiesTableValues,
          PERIODS_OPERATION_TYPES.ADD,
        );

        setValue(currentLiabilitiesFiled, currentLiabilitiesTotal);
      }, 500),
     
    [],
  );

  return getTotalCurrentLiabilitiesCalculationHandler;
};
